import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LandingPage } from '@src/app/shared/enums/LandingPage.enum';

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {
  constructor(public translate: TranslateService) { }

getLandingPageOptions(): { label: string; value: string }[] {
  return Object.values(LandingPage)
    .filter(value => typeof value === 'number')
    .map(value => {
      const name = LandingPage[value as LandingPage];

      return {
        label: this.translate.instant(`ENUMS.LANDINGPAGE_${name}`),
        value: name
      };
    });
}
}
